import React from 'react';
import { StyledOnboardingTasks } from './index.styled';
import Tasks from './Tasks';
import Panel from './Panel';

const OnboardingTasks = ({ onClose }) => (
  <StyledOnboardingTasks>
    <div className="container-onboarding-tasks">
      <Tasks showHeader onClose={onClose} />
      <Panel />
    </div>
  </StyledOnboardingTasks>
);

export default OnboardingTasks;
